import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indianNumber'
})
export class IndianNumberPipe implements PipeTransform {

  transform(value: number | string): string {
    // Handle zero input and undefined/null values
    if (value === 0 || value === '0') {
      return '0.00';
    }

    if (value === undefined || value === null) {
      return '0.00'; // Return a placeholder for undefined/null
    }

    // Convert value to a string if it is a number
    if (typeof value === 'number') {
      value = value.toString();
    }

    // Check if the value is negative
    const isNegative = value.startsWith('-');
    if (isNegative) {
      value = value.slice(1); // Remove the negative sign temporarily
    }

    // Split the number into integer and decimal parts
    const x = value.split('.');
    let integerPart = x[0];
    const decimalPart = x.length > 1 ? x[1].substring(0, 2) : '00'; // Get the first two decimal places or default to '00'

    let lastThree = integerPart.substring(integerPart.length - 3);
    const otherNumbers = integerPart.substring(0, integerPart.length - 3);
    if (otherNumbers !== '') {
      lastThree = ',' + lastThree;
    }

    // Format the integer part
    const result = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;

    // Add decimal part to the formatted result
    const formattedNumber = result + '.' + decimalPart;

    // Reapply the negative sign if needed
    return isNegative ? '-' + formattedNumber : formattedNumber;
  }

}
